import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import FashionBox from './fashionBox';
import TravelBox from './travelBox';

class FTNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fashionData, travelData, fashionAndTravelAd },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <FashionBox content={fashionData} />
                    <TravelBox content={travelData} />
                </div>
                {fashionAndTravelAd ? <Ad content={fashionAndTravelAd} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(FTNews);
